import Vue from "vue";
import switch2editionApp from "./components/Switch2Edition.vue";
import "@/common/adobetypekit.js";
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: "#f7e04b",
        secondary: "#212121",
        accent: "#f7e04b",
        info: "#C62828",
        warning: "#FFE57F",
      },
      dark: {
        primary: "#f7e04b",
        secondary: "#212121",
        accent: "#f7e04b",
        info: "#C62828",
        warning: "#FFE57F",
      },
    },
    options: { customProperties: true },
  },
});

new Vue({
  vuetify,
  render: (h) => h(switch2editionApp),
}).$mount("#app");
